import { Component } from '@angular/core';
import { HttpMemberService } from '../../../service/http-member.service';
import { Router } from '@angular/router';
import { BulkUploadDto, BulkUploadFileDto, BulkUploadSettingDto, FileUploadDto } from '../../../service/dto';
import { HttpBulkUploadService } from '../../../service/http-bulk-upload.service';
import { HttpFileService } from '../../../service/http-file.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { finalize } from 'rxjs';
import { HttpEventType } from '@angular/common/http';


class OptionWrapper {
	payload!: BulkUploadSettingDto;
	uploadedFile?: FileUploadDto;
	fileName?: string;
	uploadProgress?: number;
	mainInstance!: MemberBulkUploadFormComponent;

	customUpload = (item: NzUploadXHRArgs): any => {
		return this.mainInstance.customUpload(this, item);
	}

}
@Component({
	selector: 'app-member-bulk-upload-form',
	standalone: false,
	templateUrl: './member-bulk-upload-form.component.html',
	styleUrl: './member-bulk-upload-form.component.scss'
})
export class MemberBulkUploadFormComponent {
	options: OptionWrapper[] = [];
	constructor(private httpBulkUploadService: HttpBulkUploadService, private fileService: HttpFileService, private router: Router) {

	}
	ngOnInit(): void {
		this.httpBulkUploadService.getOptions("Member").subscribe(result => this.options = result.map(item => {
			let out = new OptionWrapper();
			out.payload = item;
			out.mainInstance = this;
			return out;
		}));
	}

	customUpload = (wrapper: OptionWrapper, item: NzUploadXHRArgs): any => {
		wrapper.uploadProgress = 0;

		const subscription = this.fileService.uploadWithProgress(item.name ?? 'bulk-member-upload', item.file as any)
			.pipe(finalize(() => wrapper.uploadProgress = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						wrapper.uploadProgress = 100;
						wrapper.uploadedFile = event.body as FileUploadDto;
						wrapper.fileName = item.file.name;
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						wrapper.uploadProgress = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}

	canSubmit(): boolean {
		return !this.options.some(item => !item.uploadedFile);
	}
	doSave() {

		const payload = new BulkUploadDto();
		payload.type = "Member";
		payload.files = this.options.map(item => {
			const file = new BulkUploadFileDto();
			file.name = item.payload.name;
			file.file = item.uploadedFile!;
			return file;
		});
		this.httpBulkUploadService.create("Member", payload).subscribe(result => this.router.navigate(["/member", "bulk", "list"]));
	}

}
